import React from "react";
import { Link } from "react-router-dom";
import Header from "../inc/Header";

import kitchen from "../images/KITCHENA2Z.jpg";
import pujaroom from "../images/TA2Z.jpg";
import interiornew from "../images/BUSINESSA2Z.jpg";
import Room from "../images/room2.jpeg"
import Kithcen2 from "../images/kitchen2.jpeg"
import jangobar from "../images/JANGO_BAR.jpg";
import ReactWhatsapp from "react-whatsapp";


import "./Home.css";
import ScrollToTop from "react-scroll-to-top";
import {
  FacebookShareButton, WhatsappShareButton, WhatsappIcon,
  FacebookIcon, TwitterShareButton, EmailShareButton, EmailIcon,

  LinkedinShareButton,
  LinkedinIcon,
  TwitterIcon,
} from "react-share";
import Slider from "../inc/Slider";
import Latestd from "./Latestd";
import Newwork from "./Newwork";

function Home(props) {
  return (
    <>

      <Header />
      <br />
      <br />
      <br />
      <br />



      <div className="album py-2">

        <div className="container ">
          <div className="row ">
            <div className="col-md-8 mt-3">
              <Slider />
            </div>
            <div className="col-md-4 mt-3">
              <div className="card border-primary mb-3" >
                <h4 className='btn-grad67'>IMPORTANT LINKS</h4>
                <div className="card-body text-primary">
                  <br />
                  <a href='about'>
                    <div className='btn-grad42 mb-2'>ABOUT US <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></div></a>
                  <a href='contact'>
                    <div className='btn-grad42 mb-2'>CONTACT US <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></div></a>
                  <center>
                    <ReactWhatsapp number="+91 9732000307" className="btn-grad42" message="I'am Interested"> Whatsapp Inquiry <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
                      <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                    </svg></ReactWhatsapp>
                  </center>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

<center>
 <a style={{color:"#fff"}} href="#" className="highlight-btn a2zfonts  mt-2">
  
    The website development is currently in progress and is expected to be completed within the next <b style={{color:"#fadfaa"}}>four days</b>.

</a>
</center>
<br/>
      <div className="bcchange">
        <div className="album py-0">
          <div className="container ">
            <marquee className="mt-2">  नमस्कार INDIA! Welcome A2Z India, *India's Best Service Provider </marquee>
          </div>
        </div>
      </div>
      <ScrollToTop smooth top="100" color="grey" />
      <div style={{ color: "Green", display: 'flex', justifyContent: 'flex-start', margin: "8px" }} className="fixed-bottom  mb-1"> <ReactWhatsapp number="+91  9732000307" className="circlewhatsapp" message="I am Interested"> <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
        <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
      </svg>   </ReactWhatsapp></div>

      <div className="album py-2">
        <div className="container " >
          <div className="row ">
            <div className="col-md-4 mt-3">


              <div className="card" >
                <div className="shrink">
                  <img src={Room} class="card-img-top" alt="a2zindia" />
                </div>
                <div class="card-body">
                  <h5 className="card-title mb-1">Daining</h5>
                  <p className="card-text"> Quality & Trust  </p>

                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className="card" >
                <div className="shrink">
                  <img src={Kithcen2} class="card-img-top" alt="a2zindia" />
                </div>
                <div class="card-body">
                  <h5 class="card-title mb-1">kitchen</h5>
                  <p class="card-text">Quality & Trust </p>

                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className="card" >
                <div className="shrink">
                  <img src={jangobar} class="card-img-top" alt="jangobar" />
                </div>
                <div class="card-body">
                  <h5 className="card-title mb-1">BAR & Restaurant</h5>
                  <p className="card-text">Quality & Trust </p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
<Newwork/>
      <div className="album py-1">
        <div className="container">
          <h1 style={{ color: "grey" }}>Latest Design (Our Work)</h1>
        </div>
      </div>
      <Latestd />
      <br />

      <div className="backcolor">
        <br />

        <center>
          <div className="mainh">
            <div className="container">
              <h3 >Best Selling Product</h3>
            </div>
          </div>
        </center>

        <div className="album py-2">
          <div className="container ">
            <div className="row  ">
              <div className="col-md-4 mt-2">
                <div className='cardhover'>
                  <div className="card">
                    <img src={kitchen} className="card-img-top" alt="kitchen" />
                    <div className="card-body">
                      <h5 className="card-title">Kitchen</h5>
                      <p className="card-text">No1 Kitchen Interior Design Provider</p>
                      <a href="#" className="courses">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg></a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mt-2">
                <div className='cardhover'>
                  <div className="card">
                    <img src={pujaroom} className="card-img-top" alt="pujaroom" />
                    <div className="card-body">
                      <h5 className="card-title">Dressing Table</h5>
                      <p className="card-text">Best Dressing Table Design at A2zindia</p>
                      <a href="#" className="courses">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg></a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-2">
                <div className='cardhover'>
                  <div className="card">
                    <img src={interiornew} className="card-img-top" alt="kitchen" />
                    <div className="card-body">
                      <h5 className="card-title">Puja Room</h5>
                      <p className="card-text">Best Interior in West Bengal</p>
                      <a href="#" className="courses">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg></a>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>


        <br />
      </div>



    </>
  );
}

export default Home;